import { render, staticRenderFns } from "./ThgImpactFactor.vue?vue&type=template&id=7ba4b521&scoped=true"
import script from "./ThgImpactFactor.vue?vue&type=script&lang=ts"
export * from "./ThgImpactFactor.vue?vue&type=script&lang=ts"
import style0 from "./ThgImpactFactor.vue?vue&type=style&index=0&id=7ba4b521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba4b521",
  null
  
)

export default component.exports